import {
  AREA_OF_OCCUPANCY_ID, DISTINCT_GENETIC_DIVERSITY_ID,
  EXTENT_OF_SUITABLE_HABITAT_ID, NUMBER_OF_LOCALITIES_ID,
  NUMBER_OF_MATURE_INDIVIDUALS_ID, RANGE_ID
} from './speciesParameterType'

export const SEASON_RESIDENT_ID = 1
export const SEASON_BREEDING_ID = 2
export const SEASON_NON_BREEDING_ID = 3
export const SEASON_MIGRATION_ID = 4

export const congregatoryGroupOptions = [
  {value: null, label: 'Not Applicable'},
  {value: 1, label: 'Waterbirds'},
  {value: 2, label: 'Seabirds'},
  {value: 6, label: 'Terrestrial'}
]

export const seasonOptions = [
  {
    id: SEASON_RESIDENT_ID,
    name: 'Resident'
  },
  {
    id: SEASON_BREEDING_ID,
    name: 'Breeding'
  },
  {
    id: SEASON_NON_BREEDING_ID,
    name: 'Non-breeding'
  },
  {
    id: SEASON_MIGRATION_ID,
    name: 'Migration'
  }
]

export const parameterOptions = [
  {
    season: SEASON_RESIDENT_ID,
    id: NUMBER_OF_MATURE_INDIVIDUALS_ID,
    name: 'number of mature individuals',
    label: '(i)'
  },
  {
    season: SEASON_RESIDENT_ID,
    id: AREA_OF_OCCUPANCY_ID,
    name: 'area of occupancy',
    label: '(ii)'
  },
  {
    season: SEASON_RESIDENT_ID,
    id: EXTENT_OF_SUITABLE_HABITAT_ID,
    name:'extent of suitable habitat',
    label: '(iii)'
  },
  {
    season: SEASON_RESIDENT_ID,
    id: RANGE_ID,
    name: 'range',
    label: '(iv)'
  },
  {
    season: SEASON_RESIDENT_ID,
    id: NUMBER_OF_LOCALITIES_ID,
    name: 'number of localities',
    label: '(v)'
  },
  {
    season: SEASON_RESIDENT_ID,
    id: DISTINCT_GENETIC_DIVERSITY_ID,
    name: 'distinct genetic diversity',
    label: '(vi)'
  },
  {
    season: SEASON_BREEDING_ID,
    id: NUMBER_OF_MATURE_INDIVIDUALS_ID,
    name: 'number of mature individuals',
    label: '(i)'
  },
  {
    season: SEASON_BREEDING_ID,
    id: AREA_OF_OCCUPANCY_ID,
    name: 'area of occupancy',
    label: '(ii)'
  },
  {
    season: SEASON_BREEDING_ID,
    id: EXTENT_OF_SUITABLE_HABITAT_ID,
    name:'extent of suitable habitat',
    label: '(iii)'
  },
  {
    season: SEASON_BREEDING_ID,
    id: RANGE_ID,
    name: 'range',
    label: '(iv)'
  },
  {
    season: SEASON_BREEDING_ID,
    id: NUMBER_OF_LOCALITIES_ID,
    name: 'number of localities',
    label: '(v)'
  },
  {
    season: SEASON_BREEDING_ID,
    id: DISTINCT_GENETIC_DIVERSITY_ID,
    name: 'distinct genetic diversity',
    label: '(vi)'
  },
  {
    season: SEASON_NON_BREEDING_ID,
    id: NUMBER_OF_MATURE_INDIVIDUALS_ID,
    name: 'number of mature individuals',
    label: '(i)'
  },
  {
    season: SEASON_NON_BREEDING_ID,
    id: AREA_OF_OCCUPANCY_ID,
    name: 'area of occupancy',
    label: '(ii)'
  },
  {
    season: SEASON_NON_BREEDING_ID,
    id: EXTENT_OF_SUITABLE_HABITAT_ID,
    name:'extent of suitable habitat',
    label: '(iii)'
  },
  {
    season: SEASON_NON_BREEDING_ID,
    id: RANGE_ID,
    name: 'range',
    label: '(iv)'
  },
  {
    season: SEASON_NON_BREEDING_ID,
    id: NUMBER_OF_LOCALITIES_ID,
    name: 'number of localities',
    label: '(v)'
  },
  {
    season: SEASON_NON_BREEDING_ID,
    id: DISTINCT_GENETIC_DIVERSITY_ID,
    name: 'distinct genetic diversity',
    label: '(vi)'
  },
  {
    season: SEASON_MIGRATION_ID,
    id: NUMBER_OF_MATURE_INDIVIDUALS_ID,
    name: 'number of mature individuals',
    label: '(i)'
  },
  {
    season: SEASON_MIGRATION_ID,
    id: AREA_OF_OCCUPANCY_ID,
    name: 'area of occupancy',
    label: '(ii)'
  },
  {
    season: SEASON_MIGRATION_ID,
    id: EXTENT_OF_SUITABLE_HABITAT_ID,
    name:'extent of suitable habitat',
    label: '(iii)'
  },
  {
    season: SEASON_MIGRATION_ID,
    id: RANGE_ID,
    name: 'range',
    label: '(iv)'
  },
  {
    season: SEASON_MIGRATION_ID,
    id: NUMBER_OF_LOCALITIES_ID,
    name: 'number of localities',
    label: '(v)'
  },
  {
    season: SEASON_MIGRATION_ID,
    id: DISTINCT_GENETIC_DIVERSITY_ID,
    name: 'distinct genetic diversity',
    label: '(vi)'
  }
]
